export const commentTableOption = {
  // 评论列表信息（帖子/文章相应评论）
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [ {
    label: '内容',
    width: 320,
    prop: 'content',
    overHidden: true,
    solt: true,
    align: 'center'
  }, {
    label: '发布者',
    width: 120,
    prop: 'commentByName',
    solt: true,
    align: 'center'
  }, {
    label: '帖子标题',
    prop: 'postTitle',
    solt: true,
    overHidden: true,
    align: 'center',
    width: 320,
  }, {
    label: '点赞',
    prop: 'likeCount',
    align: 'center',
    width: 110,
    sortable: true,
  }, {
    // isBanned 是否被下架/删除
    // 0 = 已上架 1 = 已下架 2 = 被删除
    label: '状态',
    prop: 'status',
    align: 'center',
    width: 100,
  }, {
    // type: 'datetime',
    // valueFormat: 'timestamp',
    // format: 'yyyy-MM-dd hh:mm:ss',
    label: '发布时间',
    width: 180,
    prop: 'commentTime',
    align: 'center',
    sortable: true
  }]
};

export const commentLikeTableOption = {
  page:false,
  border: true,
  stripe: true,
  align: 'center',
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  menu: false,
  column: [ {
    label: '点赞时间',
    width: 200,
    prop: 'likeTime',
    align: 'center'
  }, {
    label: '用户Full Name',
    prop: 'nickname',
    align: 'center'
  }, {
    label: '用户Birth Name',
    prop: 'realname',
    align: 'center'
  }]
};
